<template>
    <div v-show="questions && questions.length > 0" class="question-container">
        <div class="question-title">
            {{ tipTxt || '猜您想问'}}
            <span v-if="showRefresh" class="refresh" @click="refresh">
                <img src="../../assert/refresh.png" alt> 换一组
            </span>
        </div>
        <ul class="question-list">
            <li
                v-for="(item,index) in questions"
                :key="index"
                @click="clickThis(item)"
            >{{ item.QuestionContent || item }}</li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "question-list",
    props: {
        tipTxt: String,
        showRefresh: Boolean,
        questions: Array,
        msgid: Number,
        basequestion: String,
        questiontype: Number
    },
    computed: {
        ...mapGetters({
            customerState: "customerState"
        })
    },
    methods: {
        refresh() {
            Bus.$emit("refreshQuestions", this.msgid);
        },
        clickThis(item) {
            if (this.customerState != 2) {
                if (this.basequestion) item.Basequestion = this.basequestion;
                if (this.questiontype) item.Questiontype = this.questiontype;
                Bus.$emit("sendText", item);
            }
        }
    }
};
</script>

<style>
.question-container {
    background-color: #fff;
    min-width: 288px;
    width: 100%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    user-select: none;
}
@media screen and (min-width: 800px) {
    .question-container {
        max-width: 530px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/templates/QuestionList.vue